var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.858,
    height: 20,
    viewBox: "0 0 31.858 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bubble-chat",
    transform: "translate(0 -31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12220",
    "data-name": "Path 12220",
    d: "M29.87,52.077a10.562,10.562,0,0,0-1.6-14.092,12.461,12.461,0,0,0-7.016-3.164c-.016-.02-.033-.04-.052-.06A12.612,12.612,0,0,0,12.133,31C5.541,31,0,35.911,0,42.2a10.513,10.513,0,0,0,1.986,6.144L.168,54.05a.933.933,0,0,0,1.312,1.115l5.527-2.81a12.815,12.815,0,0,0,3.585.955,12.528,12.528,0,0,0,9.13,3.823,13.053,13.053,0,0,0,5.125-1.045L30.375,58.9a.933.933,0,0,0,1.312-1.115Zm-22.486-1.6a.933.933,0,0,0-.823.011l-3.937,2L3.91,48.454a.933.933,0,0,0-.154-.858,8.7,8.7,0,0,1-1.89-5.4c0-5.146,4.605-9.333,10.266-9.333A10.944,10.944,0,0,1,18.387,34.8c-5.995.6-10.8,5.285-10.8,11.132a10.464,10.464,0,0,0,1.345,5.138,10.8,10.8,0,0,1-1.551-.595Zm17.91,3.744a.933.933,0,0,0-.823-.011,11.13,11.13,0,0,1-4.748,1.056c-5.661,0-10.266-4.187-10.266-9.333S14.062,36.6,19.723,36.6s10.266,4.187,10.266,9.333a8.7,8.7,0,0,1-1.89,5.4.934.934,0,0,0-.154.858l1.286,4.036Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 0.933,
    cy: 0.933,
    r: 0.933,
    transform: "translate(14.995 45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 0.933,
    cy: 0.933,
    r: 0.933,
    transform: "translate(18.728 45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 0.933,
    cy: 0.933,
    r: 0.933,
    transform: "translate(22.461 45)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/messageIcon.4a2e6e32646d292c857f43905d8ed6f4.svg";
export { ForwardRef as ReactComponent };